import React, { useState, useEffect, useRef } from "react";
import { msalInstance } from "../index";
import { loginRequest } from "../authConfig";
import { toast } from "react-toastify";
import SearchBox from "./common/SearchBox";
import { getClinicalResourceLibrary } from "./services/soar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function ClinicalResourceLibrary({ getAccessToken }) {
  const [crl, setCrl] = useState({});
  const [tags, setTags] = useState([]);
  const [filters, setFilters] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const isMountedRef = useRef(true);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const [expanded, setExpanded] = useState(false);

  const getTooltipPlacement = () =>
    window.innerWidth < 768 ? "left" : "right";

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMountedRef.current && expanded === true) {
      loadCRL();
    }
  }, [expanded]);

  useEffect(() => {
    // Initialize all tooltips
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
      new window.bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: "click hover",
      });
    });
  }, [expanded]);

  const loadCRL = async () => {
    const accessToken = await msalInstance.acquireTokenSilent({
      scopes: loginRequest.scopes,
    });
    // console.log("Received CRL Access Token", accessToken.accessToken);

    if (accessToken?.accessToken) {
      // const client = graph.Client.init({
      //   authProvider: (done) => {
      //     done(null, accessToken);
      //   },
      // });

      // const response = await client
      //   .api(
      //     "/drives/b!Zarky5-LukCMg4hnrFO8r06b00Id9-5FtfiKk6_Yp0pT7QD6qUoMTJGER-GkFZwS/items/0135PPNMSP2YVWWZOGQRAIIHKE7QGMO4LP/children?$expand=listItem"
      //   )
      //   .get();
      toast.info("Loading Clinical Resource Library");
      getClinicalResourceLibrary(accessToken?.accessToken).then((response) => {
        if (response) {
          // console.log("CRL Items", response);
          const respValue = response;
          setCrl(respValue);

          let responseTags = [];

          respValue?.forEach((doc) => {
            if (
              doc?.listItem?.fields?.Tags &&
              Array.isArray(doc?.listItem?.fields?.Tags)
            ) {
              doc?.listItem?.fields?.Tags?.forEach((tag) => {
                if (!responseTags?.includes(tag)) {
                  responseTags?.push(tag);
                }
              });
            }
          });

          setTags(
            responseTags?.sort((a, b) => {
              if (a > b) return 1;
              else if (a < b) return -1;
              return 0;
            })
          );
        }
      });

      // const allUSers = response.value.map((u) => {
      //   return {
      //     name: u.displayName,
      //     _id: u.id,
      //     email: u.mail,
      //     domainName: `safy\\${u.mail.split("@")[0]}`,
      //   };
      // });
    }
  };

  const checkFilter = (item) => {
    let check = 0;
    filters?.forEach((f) => {
      if (item?.listItem?.fields?.Tags?.includes(f)) {
        check++;
      }
    });
    return check >= filters?.length &&
      item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      ? item
      : null;
  };

  const openResource = (item) => {
    if (item?.webUrl?.includes(".url")) {
      fetch(item?.["@microsoft.graph.downloadUrl"])
        .then((res) => res.text())
        .then((text) => {
          const url = text?.split("URL=")?.[1]?.split("\n")?.[0];
          window.open(url);
        });
    } else {
      window.open(item?.["@microsoft.graph.downloadUrl"]);
    }
  };

  return (
    <div className="border p-2 mb-4 card-safy mt-2">
      <div className="h4">
        <i
          className={
            expanded
              ? `fas fa-chevron-up p-1 text-primary`
              : `fas fa-chevron-down p-1 text-primary`
          }
          onClick={() => {
            setExpanded(!expanded);
          }}
        />
        Clinical Resource Library
      </div>
      {expanded ? (
        <>
          {tags && tags?.length > 0 && (
            <div className="border rounded p-2 mb-4">
              <div className="row mb-2">
                <div className="col">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <SearchBox
                        name="seaarchBox"
                        value={searchQuery}
                        onChange={(e) =>
                          setSearchQuery(e?.currentTarget?.value)
                        }
                        clearSearch={() => setSearchQuery("")}
                        placeholder="Search Name"
                      />
                    </div>
                    <div className="flex-shrink-0 ms-2 d-flex align-items-center">
                      <OverlayTrigger
                        placement={getTooltipPlacement()}
                        trigger="click"
                        rootClose
                        overlay={
                          <Tooltip id="info-tooltip">
                            <div>
                              If you have a clinical resource you would like
                              added to this library, please reach out to Aubrey
                              Sullivan at{" "}
                              <a
                                href="mailto:obradovicha@safy.org"
                                className="text-primary"
                                onClick={(e) => e.stopPropagation()}
                              >
                                obradovicha@safy.org
                              </a>
                            </div>
                          </Tooltip>
                        }
                      >
                        <i
                          className="fas fa-question-circle text-primary"
                          style={{ fontSize: "1.25rem", cursor: "pointer" }}
                        />
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {tags?.map((tag, index) => (
                  <button
                    key={`${index}${tag}`}
                    className={
                      filters?.includes(tag)
                        ? "btn btn-success m-1"
                        : "btn btn-safy-info m-1"
                    }
                    onClick={() => {
                      if (filters?.includes(tag)) {
                        const selected = filters?.filter((i) => i !== tag);
                        setFilters(selected);
                      } else {
                        let selected = [...filters];
                        selected?.push(tag);
                        setFilters(selected);
                      }
                    }}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>
          )}
          {crl && Array.isArray(crl)
            ? filters && filters?.length === 0 && searchQuery === ""
              ? crl?.map((item, index) => (
                  <div
                    key={`all${index}${item?.id}`}
                    className="row justify-content-between bg-light my-2 p-2 border mx-2"
                    title={item?.listItem?.fields?.Tags}
                  >
                    <div className="col-auto">{item?.name}</div>
                    <div className="col-auto">
                      {!item?.webUrl?.includes(".url") ? (
                        <i
                          className="fas fa-eye pe-4 text-primary"
                          onClick={() => window.open(item?.webUrl)}
                        />
                      ) : null}
                      <i
                        className={`fas text-primary ${
                          item?.webUrl?.includes(".url")
                            ? "fa-arrow-up-right-from-square"
                            : "fa-file-pdf fa-lg"
                        }`}
                        onClick={() => {
                          openResource(item);
                        }}
                      />
                    </div>
                  </div>
                ))
              : crl?.filter(checkFilter)?.map((item, index) => (
                  <div
                    key={`filtered${index}${item?.id} `}
                    className="row justify-content-between bg-light my-2 p-2 border mx-2"
                    title={item?.listItem?.fields?.Tags}
                  >
                    <div className="col-auto">{item?.name}</div>
                    <div className="col-auto">
                      {!item?.webUrl?.includes(".url") ? (
                        <i
                          className="fas fa-eye pe-4 text-primary"
                          onClick={() => window.open(item?.webUrl)}
                        />
                      ) : null}
                      <i
                        className={`fas text-primary ${
                          item?.webUrl?.includes(".url")
                            ? "fa-arrow-up-right-from-square"
                            : "fa-file-pdf fa-lg"
                        }`}
                        onClick={() => {
                          openResource(item);
                        }}
                      />
                    </div>
                  </div>
                ))
            : null}
        </>
      ) : null}
    </div>
  );
}

export default ClinicalResourceLibrary;
